import { render, staticRenderFns } from "./JobStatus.vue?vue&type=template&id=fbfc4a4c"
import script from "./JobStatus.vue?vue&type=script&lang=js"
export * from "./JobStatus.vue?vue&type=script&lang=js"
import style0 from "./JobStatus.vue?vue&type=style&index=0&id=fbfc4a4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports